import { useFlag } from '../../services/launchDarkly';

import { PopperTooltip } from './PopperTooltip';
import type { BasePopperTooltipProps, RedesignPopperTooltipProps } from './types';
import { UiRedesignPopperTooltip } from './UiRedesignPopperTooltip';

const Tooltip = (props: BasePopperTooltipProps | RedesignPopperTooltipProps) => {
  const newDesignTooltip = useFlag('ui_redesign_tooltip', false);

  if (newDesignTooltip && props.supportsNewTooltipDesign) {
    return <UiRedesignPopperTooltip {...(props as RedesignPopperTooltipProps)} />;
  }

  return <PopperTooltip {...props} />;
};

export default Tooltip;
